<img [style.height]="height" [style.width]="width" class="svg-icon {{ cssClass }}" src="{{ svg }}" />
